import moment from 'moment';

// A project's auto-close window (in minutes) as the forms' hours and minutes fields; zeros when
// it has none.
export const splitAutocloseWindow = (windowMinutes: number | null | undefined) => {
  if (!windowMinutes) {
    return { autocloseHours: 0, autocloseMinutes: 0 };
  }

  const duration = moment.duration(windowMinutes, 'minutes');

  return { autocloseHours: Math.floor(duration.asHours()), autocloseMinutes: duration.minutes() };
};

// The forms' hours and minutes fields as an auto-close window in minutes.
export const joinAutocloseWindow = (hours: number, minutes: number) =>
  moment.duration(hours, 'hours').add(minutes, 'minutes').asMinutes();
